import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  constructor(private http: HttpClient) { }

  getProviderById(id: any) {
    const param = new HttpParams().set('providerBranchId', id);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiEnrolUrl + '/api-mobile/get-provider-info-by-qr-id', httpOptions);
  }

  getStates() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiEnrolUrl + '/api-mobile/getStates', httpOptions);
  }

  getCities(stateId: any) {
    const param = new HttpParams().set('id', stateId);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiEnrolUrl + '/api-mobile/getCityByState', httpOptions);
  }

  getAllTpa() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiEnrolUrl + '/api-mobile/get-all-tpa', httpOptions);
  }

  getHospitalWithCity(query: any, state: any) {
    const param = new HttpParams()
      .set('qStr', query)
      .append('searchParameter', state)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiEnrolUrl + '/api-mobile/searchHospitalWithCityOrPincode', httpOptions);
  }

  saveDraftClaim(claimData: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiEnrolUrl + '/api-mobile/save-draft-claim', claimData, httpOptions);
  }

  getAllProviderQueries(data: any){
    const params = new HttpParams().set('token',data)
    let token: any = null;
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    } else if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
  
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Token ' + token
      }),
      params: params 
    };
    return this.http.get( environment.apiBaseUrl+'/get-all-Queries', httpOptions) 
   }

   responseQuery(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8'
      }),
    };
    return this.http.post( environment.apiBaseUrl + '/response-query', formData, httpOptions);
  }
}
